// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// Last line of defense: if a response ever comes back without the frame a
// form targeted, Turbo would render literal "Content missing". Render a
// human sentence instead (the server passes it on the frame element).
document.addEventListener("turbo:frame-missing", (event) => {
  event.preventDefault()
  const frame = event.target
  const message = frame.dataset.missingMessage ||
    "That didn't go through. Reload the page and try again."
  frame.innerHTML = `<div class="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800">${message}</div>`
})
